var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"nav-bar"},[_c('el-button',{attrs:{"icon":"el-icon-arrow-left"}},[_c('router-link',{staticClass:"back-link",attrs:{"to":"/counter"}},[_vm._v("返回")])],1)],1),_c('vue-office-docx',{attrs:{"src":_vm.docx}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }